import { Button } from 'components/atoms/button'
import { useStore } from 'hooks/useStore'
import { devMode } from 'utils/constants'

export function DidYouKnowBlock() {
	// TODO: Remove null when ready
	const { didYouKnowContent } = useStore()

	if (devMode('Hide Did You Know block')) {
		return null
	}

	return (
		<div className="card-surface space-y-4 p-5">
			<h3 className="font-title text-xl font-bold tracking-tight text-primary-text">Did You Know?</h3>
			<p className="text-sm leading-relaxed text-secondary-text">
				{didYouKnowContent ?? `You can create your own Club and Offers for your community.`}
			</p>
			<Button variant="secondary" fullWidth className="!rounded-full" disabled>
				Coming Soon
			</Button>
		</div>
	)
}
